export default function noop() {
  return null;
}
